export const SETTINGS_PAGE_TAB_OPTIONS = Object.freeze({
  General: 'general',
  Members: 'members',
});

export type SettingsPageTabOption = typeof SETTINGS_PAGE_TAB_OPTIONS[keyof typeof SETTINGS_PAGE_TAB_OPTIONS];